export default __webpack_public_path__ + "static/media/security-safe.683b5abe.svg";